define(
    'modals/secured/explorer/details/tabs/actions/DocumentActionAddErrorModal',[
        "plugins/dialog",
        "i19n!i19n/strings"
    ],
    function (dialog, i19n) {

        function Modal() {
            var self = this;

            self.i19n = i19n;
       }

   
        Modal.prototype = {
            activate: function () {

            },
            ok : function() {
                var self = this;

                dialog.close(self, { ok: true });
            }
        };

        return Modal;
    }
);
